<template>
  <div class="kb-main">
    <div class="h-full">
      <div class="h-full">
        <div
          class="vx-row py-4 bg-main h-full"
          style="overflow-x: auto; overflow-y: hidden; flex-wrap: nowrap"
        >
          <div v-for="(col, index) in 4" :key="index" class="vx-col">
            <vx-card
              class="org-card kb-col cursor-move bg-col"
              style="overflow-x: hidden; overflow-y: auto"
            >
              <div style="height: 150px">
                <!-- <div class="kanban-user-card kb-col-item p-2 mb-3">
                                </div> -->
              </div>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.kb-main {
  height: calc(100vh - 15.6rem);
  border-radius: 8px;
}

.bg-main {
  background-color: transparent !important;
}

.kanban-user-card {
  background: #f4f6fb;
  border-radius: 8px;
}

.vx-col:nth-child(1) .bg-col .kanban-user-card {
  /*background: rgba(223, 227, 235, 0.5);*/
  background: #ffffff;
}

.vx-col:nth-child(1) .bg-col {
  /*background: rgba(223, 227, 235, 0.5);*/
  background-color: #ececed;
}

.bg-col {
  background: rgba(223, 227, 235, 1);
  border-radius: 12px;
}

.org-card.kb-col {
  width: 350px !important;
  box-shadow: none;
}

.add-col {
  width: 350px !important;
  height: fit-content !important;
  border: 1px dashed #b2bac8;
  border-radius: 8px;
}

.kb-col-item {
  box-shadow: none !important;
}

@keyframes pulse-bg {
  0% {
    background-color: #f4f6fb;
  }
  50% {
    background-color: #dfe3eb;
  }
  100% {
    background-color: #f4f6fb;
  }
}

.kb-main .kb-col {
  animation: pulse-bg 1s infinite;
}
</style>
